import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-2 flex justify-end"
}
const _hoisted_2 = { class: "relative overflow-hidden rounded-2xl bg-gray-200" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-x-6 gap-y-4 border-b border-concrete-200 pb-4" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "block"
}
const _hoisted_13 = {
  key: 3,
  class: "block"
}
const _hoisted_14 = { class: "mt-4 flex justify-end" }

import { computed, ref } from "vue";

import { Translations } from "~/js/interfaces/translations";
import { Location } from "~/js/interfaces/locations";
import { getTranslation } from "~/js/composables/translations";
import { getLocationColors } from "~/js/composables/colors";
import { getLocationIconTypes } from "~/js/composables/icons";

import Badge from "~/vue/atoms/badges/BadgePrimary.vue";
import ImageTeaser from "~/vue/atoms/images/ImageTeaser.vue";
import TextCardCategory from "~/vue/atoms/texts/TextCardCategory.vue";
import TextH4 from "~/vue/atoms/texts/TextH4.vue";
import ButtonPrimary from "~/vue/atoms/buttons/ButtonPrimary.vue";

interface Props {
	location: Location;
	translations?: Translations | null;
	utilities?: string;
	hasClose?: boolean;
	stacked?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CardLocationSidebar',
  props: {
    location: {},
    translations: { default: null },
    utilities: { default: "" },
    hasClose: { type: Boolean, default: false },
    stacked: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const colors = ref(getLocationColors());
const status = computed(() => (props.location.availableNow ? "available" : "soon"));

const hasUnits = computed(() => (props.location.units?.length ?? 0) > 0);
const buildingParts = computed(() => props.location.buildingPartTypes ?? []);

const formatArea = (value: unknown): string =>
	String(value ?? "")
		.replace(/\s*m\^?2\s*/gi, "")
		.replace(/\^2/g, "")
		.trim();

const imageRatio = computed(() => (props.stacked ? "aspect-video w-full" : "aspect-video w-full sm:aspect-[4/3]"));
const buildingPartsGridClasses = computed(() =>
	props.stacked ? "mt-4 grid grid-cols-2 gap-x-4 gap-y-3" : "mt-4 grid grid-cols-2 gap-x-4 gap-y-3 lg:grid-cols-3",
);
const wrapperClasses = computed(() =>
	props.stacked
		? "rounded-2xl border border-concrete-200 bg-white p-3"
		: "rounded-3xl bg-white p-4",
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass([wrapperClasses.value, __props.utilities])
  }, [
    (__props.hasClose)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            "aria-label": "close",
            class: "flex h-10 w-10 items-center justify-center rounded-full border border-viridian-500 bg-white text-2xl text-viridian-500 focus:outline-none focus:ring-4 focus:ring-celestial-500",
            onClick: _cache[0] || (_cache[0] = () => emit('close'))
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "far fa-times" }, null, -1)
          ]))])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(props.stacked ? 'flex flex-col gap-3' : 'flex flex-col gap-3 sm:flex-row sm:gap-4')
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(props.stacked ? 'w-full order-1' : 'w-full order-1 sm:order-2 sm:w-40 sm:shrink-0 lg:w-[260px]')
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Badge, {
            content: _unref(getTranslation)(__props.translations, __props.location.availableNow ? 'Available now' : 'Available soon'),
            style: _normalizeStyle(colors.value[status.value].badge),
            utilities: "absolute left-2 top-2 z-10 !bg-white !text-viridian-500",
            size: "small"
          }, null, 8, ["content", "style"]),
          (__props.location.teaser)
            ? (_openBlock(), _createBlock(ImageTeaser, {
                key: 0,
                image: __props.location.teaser,
                ratio: imageRatio.value,
                sizes: ['(max-width: 639px) 100vw', '260px']
              }, null, 8, ["image", "ratio"]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(props.stacked ? 'min-w-0 grow order-2' : 'min-w-0 grow order-2 sm:order-1')
      }, [
        _createVNode(TextCardCategory, {
          content: __props.location.type,
          icon: _unref(getLocationIconTypes)(__props.location.type),
          utilities: "mb-2 block"
        }, null, 8, ["content", "icon"]),
        _createElementVNode("h2", _hoisted_3, [
          _createVNode(TextH4, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.location.title), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(getTranslation)(__props.translations, "Rentable surface")), 1),
            (__props.location.area)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(formatArea(__props.location.area)) + " m² ", 1))
              : _createCommentVNode("", true)
          ]),
          (hasUnits.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(getTranslation)(__props.translations, "Available units")), 1),
                _createElementVNode("div", null, _toDisplayString(__props.location.units.length), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(buildingPartsGridClasses.value)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildingParts.value, (building) => {
            return (_openBlock(), _createElementBlock("article", {
              key: building.slug,
              class: "min-w-0 text-sm"
            }, [
              _createElementVNode("h3", _hoisted_9, _toDisplayString(building.title), 1),
              (building.area)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(formatArea(building.area)) + " m² ", 1))
                : (building.spaces)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(building.spaces), 1))
                  : _createCommentVNode("", true),
              (building.price && building.area)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(building.price) + " / m² / " + _toDisplayString(_unref(getTranslation)(__props.translations, "y.")), 1))
                : (building.price && building.spaces)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(building.price) + " / " + _toDisplayString(_unref(getTranslation)(__props.translations, "spot")) + " / " + _toDisplayString(_unref(getTranslation)(__props.translations, "y.")), 1))
                  : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 2)
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(ButtonPrimary, {
        size: "small",
        icon: "arrow-right",
        type: "a",
        "icon-position": "after",
        href: __props.location.url,
        content: _unref(getTranslation)(__props.translations, __props.location.type === 'building' ? 'View building' : 'View project')
      }, null, 8, ["href", "content"])
    ])
  ], 2))
}
}

})